import { Link, Outlet } from 'react-router-dom';
import DebtDroneMark from '@/components/icons/DebtDroneMark';
import { useNoindex } from '@/hooks/useNoindex';

// Bare, chrome-free shell for the public report share view — no sidebar,
// no auth-gated nav, just a thin identity strip so a visitor knows what
// they're looking at and where to learn more.
export default function PublicReportLayout() {
  // Report share links are unlisted: reachable with the token, never indexed.
  useNoindex();

    return (
        <div className="min-h-screen bg-background">
            <div className="border-b border-hairline">
                <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
                    <Link to="/" className="flex items-center gap-2">
                        <DebtDroneMark className="h-5 w-5" />
                        <span className="text-sm font-semibold tracking-tight">DebtDrone</span>
                    </Link>
                    <span className="font-mono text-[10px] uppercase tracking-[.06em] text-muted-foreground">
                        Shared report · view only
                    </span>
                </div>
            </div>
            <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
                <Outlet />
            </div>
        </div>
    );
}
